import React, { lazy, Suspense, useEffect, useState } from "react";
import { APP_DEFAULT_LOGIN, APP_COGNITO, ENABLE_SAML_LOGIN } from "../../Constants/Constants";
import { getApiCallHostPath } from "../../utils/apiCallFunction";
import { SAML_LOGIN_URL } from "../../Routes/Routes";

const isDefaultLogin = APP_DEFAULT_LOGIN === "true";
const isCognitoLogin = APP_COGNITO === "true";

const DefaultLoginForm = isDefaultLogin ? lazy(() => import("./LoginForm")) : null;
const CognitoComponent = isCognitoLogin ? lazy(() => import("./ExternalService/Cognito")) : null;
// const GuestUser = isDefaultLogin ? lazy(() => import("./GuestUser")) : null;

const LoginWidget = ({ domainData }) => {
  const [MicrosoftAuth, setMicrosoftAuth] = useState(null);

  useEffect(() => {
    if (domainData?.sso_microsoft) {
      import("./ExternalService/Microsoft").then((module) => {
        setMicrosoftAuth(() => module.default);
      });
    }
  }, [domainData?.sso_microsoft]);

  const handleSamlRoute = () => {
    window.location.href = `${getApiCallHostPath()}${SAML_LOGIN_URL}`;
  };

  return (
    <div className="login_outer_container">
      <div className="login_inner_container">
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h1 style={{ fontSize: "24px" }}>Login</h1>
          {/* {isDefaultLogin && (
            <Suspense fallback={<p></p>}>
              <GuestUser />
            </Suspense>
          )} */}
        </div>
        <div className="login_field">
          {isDefaultLogin && (
            <Suspense fallback={<p>Loading...</p>}>
              <DefaultLoginForm />
            </Suspense>
          )}

          {domainData?.sso_microsoft && MicrosoftAuth && <MicrosoftAuth />}

          {ENABLE_SAML_LOGIN && (
            <div className="microsoft_auth_container">
              <button onClick={handleSamlRoute} className="microsoft_auth_signin">
                <img src={require("../../Images/microsoft_logo.png")} alt="img" width={"20px"} height={"20px"} />
                <span>Login with SSO</span>
              </button>
            </div>
          )}

          {isCognitoLogin && (
            <Suspense fallback={<p>Loading...</p>}>
              <CognitoComponent />
            </Suspense>
          )}
        </div>
      </div>
    </div>
  );
};

export default LoginWidget;
